import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Swal from 'sweetalert2'; // 🚀 นำเข้ากล่องแจ้งเตือนสุดสวยกลับมาแล้ว!

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();
  const API_URL = 'https://app.thundermaxhome.com/api.php';

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) return;

    setLoading(true); // สั่งปุ่มหมุน

    try {
      const res = await fetch(`${API_URL}?action=login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();

      if (data.success && data.user) {
        // ดักจับสิทธิ์ ถ้าไม่ใช่ช่าง แอดมิน ไอที หรือเจ้าของระบบ ไม่ให้เข้าระบบคิวช่าง
        const allowedRoles = ['tech', 'owner', 'admin', 'it'];
        if (!allowedRoles.includes(data.user.role)) {
           Swal.fire('ปฏิเสธการเข้าถึง', 'พื้นที่นี้สำหรับช่างเทคนิคและผู้ดูแลระบบเท่านั้น!', 'error');
           setLoading(false);
           return;
        }
        // ล็อกอินผ่าน เด้งเข้าตามสิทธิ์
        login(data.user, true); // จำไอดีผู้ใช้ไว้ในเครื่องเสมอ
        navigate('/tech');
      } else {
        // แจ้งเตือนแบบสวยหรูเมื่อรหัสผิด
        Swal.fire({
          icon: 'error',
          title: 'เข้าสู่ระบบไม่สำเร็จ',
          text: data.message || 'ไอดีหรือรหัสผ่านไม่ถูกต้อง',
          confirmButtonColor: '#2563eb', // สีปุ่มให้เข้ากับธีม
          borderRadius: '1rem'
        });
      }
    } catch (error) {
      console.error("Login Error:", error);
      // แจ้งเตือนสวยๆ เวลาเน็ตหลุด หรือ เซิร์ฟเวอร์ตาย
      Swal.fire({
        icon: 'error',
        title: 'เซิร์ฟเวอร์ไม่ตอบสนอง',
        text: 'ไม่สามารถเชื่อมต่อระบบหลักได้ กรุณาตรวจสอบอินเทอร์เน็ต',
        confirmButtonColor: '#2563eb',
        borderRadius: '1rem'
      });
    } finally {
      // 🚀 ปุ่มหยุดหมุนเสมอ ไม่ว่าจะเกิดอะไรขึ้น!
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950 flex flex-col justify-center items-center p-4 font-sans transition-colors duration-300">
      <div className="bg-white dark:bg-[#131825] w-full max-w-md p-8 rounded-3xl shadow-xl border border-gray-100 dark:border-gray-800 transition-all duration-300">
        
        {/* โลโก้บริษัท */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-blue-50 dark:bg-blue-950/20 rounded-full flex items-center justify-center border-4 border-white dark:border-gray-800 shadow-sm text-4xl font-black text-blue-600 dark:text-blue-400">
            TM
          </div>
        </div>
        
        <h1 className="text-center text-xl font-bold text-gray-800 dark:text-white mb-8">ระบบบริหารจัดการคิวช่าง</h1>
        
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">ไอดีผู้ใช้งาน (ID)</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all font-medium placeholder-gray-400 dark:placeholder-gray-500"
              placeholder="กรอกไอดีของคุณ"
              required
            />
          </div>
          <div>
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">รหัสผ่าน</label>
            </div>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all font-medium placeholder-gray-400 dark:placeholder-gray-500"
              placeholder="••••••••"
              required
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            className={`w-full text-white font-bold py-4 rounded-xl shadow-lg transition-all mt-4 ${loading ? 'bg-blue-300 dark:bg-blue-800 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700 shadow-blue-500/30 dark:shadow-none'}`}
          >
            {loading ? 'กำลังตรวจสอบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>
      </div>
      <p className="text-gray-400 dark:text-gray-600 text-xs mt-6">Powered by Thunder Maxhome</p>
    </div>
  );
}